export const getIdFromObject = (obj: any) => {
  const id = obj.value.split(' - ')[0];
  return id;
};
